<script>
import { AppTracker } from '@/components/ui/tracker'
import { WarehouseService } from '@/services'

const BaseOverview = () => import('../components/BaseOverview')

export default {
  data() {
    return {
      targetWeight: 0,
      currentWeight: 0,
      gold9650Weight: 0,
      lack: 0,
      over: 0,
      isLoading: false
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      this.isLoading = true

      try {
        const {
          data: { result }
        } = await WarehouseService.sell.getOverview()

        this.targetWeight = result.suggest_real_weight_total
        this.currentWeight = result.remaining_real_weight_total
        this.gold9650Weight = result.g23k_real_weight_total
        this.lack = result.lt_suggest_real_weight_total
        this.over = result.gt_suggest_real_weight_total
      } catch (err) {
        this.$notify.error(err.message)
      } finally {
        this.isLoading = false
      }
    }
  },

  render() {
    return (
      <BaseOverview loading={this.isLoading}>
        <AppTracker
          label="น้ำหนักตามผัง"
          value={this.targetWeight}
          unit="กรัม"
          format="0,0.00"
          labelClassName={this.$style.label}
          valueClassName={this.$style.value}
        />
        <AppTracker
          label="น้ำหนักในร้าน"
          value={this.currentWeight}
          unit="กรัม"
          format="0,0.00"
          labelClassName={this.$style.label}
          valueClassName={this.$style.value}
        />
        <AppTracker
          label="ทอง 96.5%"
          value={this.gold9650Weight}
          unit="กรัม"
          format="0,0.00"
          labelClassName={this.$style.label}
          valueClassName={this.$style.value}
        />
        <AppTracker
          label="ทองขาด"
          value={this.lack}
          unit="กรัม"
          format="0,0.00"
          labelClassName={this.$style.label}
          valueClassName={this.$style.value}
        />
        <AppTracker
          label="ทองเกิน"
          value={this.over}
          unit="กรัม"
          format="0,0.00"
          labelClassName={this.$style.label}
          valueClassName={this.$style.value}
        />
      </BaseOverview>
    )
  }
}
</script>

<style lang="scss" module>
.label {
  font-size: 1rem;
}

.value {
  font-size: 1.25rem;
}
</style>
